import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import InputFieldPassword from 'components/InputFieldPassword'
import { preRegisterFormItems } from 'utilities/resources/formItems'
import { ErrorChecker, FormErrorMessage, passwordValidator } from 'utilities/validators'
import { PropertySetter } from 'utilities/typeUtility'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { scrollToAnchor } from 'utilities/helper'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  // パスワード変更フォームの値
  const [formValues, setFormValues] = React.useState({
    currentPassword: '',
    password: '',
    passwordConfirm: '',
  })
  // パスワード変更フォームの値を更新する関数
  const setter = new PropertySetter(setFormValues)
  // パスワード変更フォームのエラーメッセージ
  const [errorValues, setErrorValues] = React.useState<FormErrorMessage<typeof formValues>>()
  const errorChecker = new ErrorChecker<typeof formValues>({
    currentPassword: { label: 'パスワード', name: 'current-password', type: 'must' },
    password: preRegisterFormItems.password,
    passwordConfirm: preRegisterFormItems.passwordConfirm,
  })

  // パスワード変更処理
  const handleSubmit = () => {
    errorChecker.init()
    errorChecker.check(passwordValidator(formValues.currentPassword), 'currentPassword')
    errorChecker.check(passwordValidator(formValues.password), 'password')
    errorChecker.check(passwordValidator(formValues.passwordConfirm, formValues.password), 'passwordConfirm')
    setErrorValues(errorChecker.getErrorMessageData())
    if (errorChecker.isValid()) {
      // TODO:パスワード変更処理をここに追加
      navigate('/passwordEditConfirm', { state: { formValues: { password: formValues.password, currentPassword: formValues.currentPassword } } })
    } else {
      scrollToAnchor(errorChecker.getFirstInvalidItemId())
    }
  }

  return (
    <>
      <Header title="パスワード変更" />
      <main>
        <section className="mx-4 my-5">
          <form>
            <InputFieldPassword
              name="current-password"
              value={formValues.currentPassword}
              onChange={(e) => setter.set('currentPassword', e)}
              label="現在のパスワード"
              type="password"
              placeholder="現在のパスワードを入力してください"
              errors={[errorValues?.currentPassword ?? '']}
              bold
              className="mb-4"
            />
            <InputFieldPassword
              name={preRegisterFormItems.password.name}
              value={formValues.password}
              onChange={(e) => setter.set('password', e)}
              label="新しいパスワード"
              type="password"
              placeholder="新しいパスワードを入力してください"
              errors={[errorValues?.password ?? '']}
              bold
              className="mb-1"
            />

            <p className="text-muted mb-4">
              ※半角英数字を含む文字で入力してください
              <br />
              ※大文字と小文字を含む文字で入力してください
              <br />
              ※8文字以上で入力してください
            </p>

            <InputFieldPassword
              name={preRegisterFormItems.passwordConfirm.name}
              value={formValues.passwordConfirm}
              onChange={(e) => setter.set('passwordConfirm', e)}
              label={preRegisterFormItems.passwordConfirm.label}
              type="password"
              placeholder="新しいパスワードを再入力してください"
              errors={[errorValues?.passwordConfirm ?? '']}
              bold
              className="mb-4"
            />

            <div className="mt-5">
              <Button variant="primary" className="w-100 py-4" onClick={handleSubmit}>
                変更する
              </Button>
            </div>

            <div className="m-4 text-center">
              <a href="/myPage">マイページに戻る</a>
            </div>
          </form>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
